import { Autocomplete, Box, ListItem, ListItemIcon, ListItemText, TextField } from "@mui/material";
import CloseIconButton from "@entrilia/shared/components/CloseIconButton";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import { stringComparerBy } from "@entrilia/shared/utilities/arrayHelper";
import FieldIcon from "../../../common/domain-icons/FieldIcon";
import FieldSourceBadge from "../../../entityFields/FieldSourceBadge";
import type { LayoutField } from "./objectLayoutState";

interface Props {
  fields: LayoutField[];
  onAdd: (fieldId: string) => void;
  onCancel: () => void;
}

const AddFieldSelect = ({ fields, onAdd, onCancel }: Props) => {
  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Escape") {
      e.stopPropagation();
      e.preventDefault();
      onCancel();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        pl: 1,
        pr: 1.5,
      }}
    >
      <Autocomplete
        fullWidth
        openOnFocus
        options={[...fields].sort(stringComparerBy((f) => f.name))}
        getOptionLabel={(f) => f.name}
        onChange={(_, field) => field && onAdd(field.id)}
        renderInput={(inputProps) => (
          <TextField {...inputProps} autoFocus placeholder="Type field name..." onKeyDown={handleInputKeyDown} />
        )}
        renderOption={({ key: _key, ...props }, field) => (
          <ListItem
            key={field.id}
            {...props}
            secondaryAction={
              <Box component="span" sx={{ pr: 1 }}>
                <FieldSourceBadge fieldSource={field.source} />
              </Box>
            }
          >
            <ListItemIcon sx={{ pl: 0, pr: 1.5, minWidth: 0 }}>
              <FieldIcon fieldType={field.type} color="action" />
            </ListItemIcon>
            <ListItemText sx={{ flexGrow: 1 }}>
              <TypographyTooltipEllipsis text={field.name} typographyProps={{ component: "span", sx: { pr: 4 } }} />
            </ListItemText>
          </ListItem>
        )}
      />
      <CloseIconButton onClick={onCancel} />
    </Box>
  );
};

export default AddFieldSelect;
